import { forwardRef } from 'react';
import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

type PortalDsButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'danger' | 'dangerGhost';

type PortalDsButtonSize = 'sm' | 'md';

const VARIANT_CLASSES: Record<PortalDsButtonVariant, string> = {
  primary: portalDs.btnPrimary,
  accent: portalDs.btnAccent,
  secondary: portalDs.btnSecondary,
  ghost: portalDs.btnGhost,
  danger: portalDs.btnDanger,
  dangerGhost: portalDs.btnDangerGhost,
};

const SIZE_CLASSES: Record<PortalDsButtonSize, string> = {
  sm: portalDs.btnSm,
  md: portalDs.btnMd,
};

export interface PortalDsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: PortalDsButtonVariant;
  size?: PortalDsButtonSize;
}

export const PortalDsButton = forwardRef<HTMLButtonElement, PortalDsButtonProps>(
  ({
    variant = 'secondary',
    size = 'md',
    className,
    type = 'button',
    ...props
  }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          portalDs.btnBase,
          VARIANT_CLASSES[variant],
          SIZE_CLASSES[size],
          className
        )}
        {...props}
      />
    );
  }
);
PortalDsButton.displayName = 'PortalDsButton';
